import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'numberFormat',
  standalone: false
})
export class NumberFormatPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(
    value: unknown,
    locale?: string,
    minFractionDigits?: number
  ): string | number | unknown {
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      isNaN(Number(value))
    ) {
      return value;
    }
    const lang = this.getInitLocale(locale);

    return this.getFormatedValue(Number(value), lang, minFractionDigits);
  }

  private getFormatedValue(value: number, locale: string, format: number) {
    if (format) {
      const theValue = value ? value : 0;
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: format
      }).format(theValue);
    }
    return value.toLocaleString(locale);
  }

  private getInitLocale(locale: string) {
    let lang = this.translateService.currentLang.toLowerCase();
    if (locale) {
      lang = locale;
    }
    if (lang === 'en') {
      return `${lang}-US`;
    }
    return `${lang}-CH`;
  }
}
